export default "__VITE_ASSET__krcRxaTK__"